import { render, staticRenderFns } from "./LeaveManagement.vue?vue&type=template&id=91defa40&scoped=true"
import script from "./LeaveManagement.vue?vue&type=script&lang=js"
export * from "./LeaveManagement.vue?vue&type=script&lang=js"
import style0 from "./LeaveManagement.vue?vue&type=style&index=0&id=91defa40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91defa40",
  null
  
)

export default component.exports